"use client";

import { useEffect } from "react";

import { strings } from "@perceptron/constants";
import { Button } from "@perceptron/ui/components/button";

import { clearDetectCategories, runDetect } from "@demo/libs/detect";
import { useDetectStore } from "@demo/store/detect";

import CategoryInput from "./CategoryInput";
import CategoryList from "./CategoryList";
import DetectExamples from "./DetectExamples";
import DetectFeedback from "./DetectFeedback";
import DetectFooter from "./DetectFooter";

/**
 * Detect's left pane: a black Categories panel (title + tab-cards + the
 * add-category input) and the footer below it. ⌘↵ / Ctrl+↵ runs detection while
 * detect mode is mounted.
 */
const DetectPanel = () => {
  const categories = useDetectStore((state) => state.categories);
  const isRunning = useDetectStore((state) => state.status === "running");

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        runDetect();
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, []);

  return (
    <div className="flex h-full w-full flex-col gap-2">
      <div className="dark relative flex min-h-0 flex-1 flex-col gap-4 overflow-hidden rounded-2xl bg-black p-4">
        <div className="flex items-center justify-between">
          <h2 className="text-foreground-primary label-2">{strings.detect.categoriesTitle}</h2>
          <div className="z-10 flex items-center gap-2">
            <DetectFeedback />
            {categories.length > 0 && (
              <Button
                className="h-auto !bg-transparent p-0 text-foreground-secondary legal"
                disabled={isRunning}
                variant="ghost"
                onClick={() => clearDetectCategories()}
              >
                {strings.detect.clearAll}
              </Button>
            )}
          </div>
        </div>
        <div className="flex min-h-0 flex-1 flex-col gap-4">
          <CategoryList />
          <div>
            <DetectExamples />
            <CategoryInput />
          </div>
        </div>
      </div>
      <DetectFooter />
    </div>
  );
};

export default DetectPanel;
